import type { GetStaticPaths, GetStaticProps } from 'next'
import CityServicePage, { CityServicePageProps } from '@src/components/CityPage/CityServicePage'
import { CITY_SERVICES, getCityPage } from '@src/content/cities'

/**
 * City pages for /hazardous-waste-disposal.
 *
 * Statically generated: the content is committed to the repo, so there is no
 * reason to render it per request. `fallback: false` means a city that is not in
 * the registry 404s rather than rendering an empty shell — no accidental thin
 * pages for Google to find.
 *
 * To add a service, copy this file to `src/pages/<service>/[city].tsx` and
 * change SERVICE_SLUG.
 */
const SERVICE_SLUG = 'oil-recycling'

export const getStaticPaths: GetStaticPaths = async () => ({
  paths: Object.keys(CITY_SERVICES[SERVICE_SLUG].cities).map((city) => ({ params: { city } })),
  fallback: false,
})

export const getStaticProps: GetStaticProps<CityServicePageProps> = async ({ params }) => {
  const page = getCityPage(SERVICE_SLUG, String(params?.city))
  if (!page) return { notFound: true }
  return { props: page }
}

export default CityServicePage
